unit Login_View;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  Home_View,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.REST, WEBLib.DBCtrls, Data.DB, WEBLib.DB, WEBLib.CDS, WEBLib.WebCtrls,
  WEBLib.ExtCtrls;

type
  TLoginView = class(TForm)
    IdTitulo: TLabel;
    mPWRD: TDBLabel;
    mIduser: TDBLabel;
    EditEmail: TEdit;
    EditPassword: TEdit;
    btnLogar: TButton;
    BtnEmail: THTMLSpan;
    BtnPassword: THTMLSpan;
    nRESP: TMemo;
    ckLocal: TCheckBox;
    WebClientDS: TClientDataSet;
    WebClientDSiduser: TIntegerField;
    WebClientDSregistro: TStringField;
    WebClientDSnome: TStringField;
    WebClientDSregname: TStringField;
    WebClientDSpwrd: TStringField;
    WebClientDSemailu: TStringField;
    WebClientDSlibera_precos: TBooleanField;
    WebClientDSvendasflags: TStringField;
    WebClientDSengenhariaflags: TStringField;
    WebClientDSpcpflags: TStringField;
    WebClientDScomprasflags: TStringField;
    WebClientDSfaturamentoflags: TStringField;
    WebClientDSrhflags: TStringField;
    WebClientDSfinanceiroflags: TStringField;
    WebClientDSqualidadeflags: TStringField;
    WebClientDSfiscalflags: TStringField;
    WebClientDSfoneu01: TStringField;
    WebClientDSativo: TIntegerField;
    WebClientDSvia_acesso: TIntegerField;
    WebClientDSsession: TStringField;
    WebConn: TClientConnection;
    WebDTS: TDataSource;
    upGestio: THttpRequest;
    gestiologin: TLinkLabel;
    procedure btnLogarClick(Sender: TObject);
    procedure EditEmailKeyPress(Sender: TObject; var Key: Char);
    procedure EditPasswordKeyPress(Sender: TObject; var Key: Char);
    procedure WebFormShow(Sender: TObject);
    procedure WebConnAfterConnect(Sender: TObject);
    procedure BtnEmailDblClick(Sender: TObject);
    procedure BtnPasswordDblClick(Sender: TObject);
    [async] procedure gestiologinClick(Sender: TObject); async;
  private
    { Private declarations }

  public
    { Public declarations }
    frm: TForm;
    Server_URL, UserName: string;
  protected procedure LoadDFMValues; override; end;

var
  LoginView: TLoginView;

implementation

{$R *.dfm}

procedure TLoginView.BtnEmailDblClick(Sender: TObject);
begin
    EditEmail.Text:= 'sidnei.lantin@gmail.com';
end;

procedure TLoginView.btnLogarClick(Sender: TObject);
var
  //sha: TWebSHAHash;
  s: string;

  b: boolean;
  FamiliaFLAG: string;
  appData,novaDATA : TDateTime;

  z, nMINUSCULAS, nMAIUSCULAS, nESPECIAIS: integer;
  nSenha: string;

  character: char;
  number: byte;
begin

      if ckLocal.Checked then
      begin
           //UserSession.FBaseURL:= 'http://localhost:8082/api';
          LoginView.Server_URL:= 'http://localhost:8082/api/';
      end else begin
          //UserSession.FBaseURL:= 'http://10.50.132.107:8082/api';
          LoginView.Server_URL:= 'http://10.50.132.107:8082/api/';
      end;

//Videos sobre este template
//S:\ContFat\Disco00_Athenas\Projetos\TMS_Core\000_Melhores_Videos\002_TMS_WEB_Core\-000_Code4Delphi

//001- Aviso sobre a falta de dados
      if TRIM(EditEmail.Text) = '' then
      begin
        ShowMessage('O email é obrigatório !');
        EditEmail.SetFocus;
        exit;
      end;

      if TRIM(EditPassword.Text) = '' then
      begin
        ShowMessage('A senha é obrigatória !');
        EditPassword.SetFocus;
        exit;
      end;
//001- Aviso sobre a falta de dados

//001- Aviso de senha curta
      if length(EditPassword.Text) < 10 then begin
          ShowMessage('Sua senha possui um comprimento menor que 10 caracteres, favor redefinir a mesma com 10 caracteres ou mais, com ao menos uma letra minúscula, uma maiúscula e um caracter especial !');
          exit;
      end;
//001- Aviso de senha curta

//002- Aviso de 1 caracter minúsculo e 1 maiúsculo
      nSenha:= EditPassword.Text;

      nMINUSCULAS := 0;
      nMAIUSCULAS := 0;
      nESPECIAIS  := 0;
      //Varre todos os caracteres da nova senha
      for z:=1 to Length(nSenha) do begin

        character := nSenha[z];     //Separa o caracter na posição
        number := Ord(character);   //Verfifia qual ASCII

        //65-90 Maiúsculas
        if (number > 64) and (number < 91) then begin
            inc(nMAIUSCULAS);   //Se for maiúscula soma variável
        end;

        //97-123 Minúsculas
        if (number > 96) and (number < 124) then begin
            inc(nMINUSCULAS);   //Se for minúscula soma variável
        end;

        //x<48 58-64  91-96  x>122 Caracteres especiais
        if (number < 48) or ((number > 57) and (number < 65)) or (number > 122) or ((number > 90) and (number < 97)) then begin  //33-47 58-64  91-96  123-126
            inc(nESPECIAIS);   //Se for especial soma variável
        end;
      end;

      if nMINUSCULAS = 0 then begin
          ShowMessage('Sua senha precisa ter ao menos um caracter MINÚSCULO !');
          exit;
      end;

      if nMAIUSCULAS = 0 then begin
          ShowMessage('Sua senha precisa ter ao menos um caracter MAIÚSCULO !');
          abort;
          exit;
      end;

      if nESPECIAIS = 0 then begin
          ShowMessage('Sua senha precisa ter ao menos um caracter ESPECIAL ex: "@#$[]{}!*"... !');
          abort;
          exit;
      end;

//002- Aviso de 1 caracter minúsculo e 1 maiúsculo

//003- Acessa o Banco
      try
        WebConn.Active := false;

        // MousePointer.Cursor := -11;
        //WebConn.URI:= 'xpwrds?emailu=' + username.Text;
        WebConn.URI:= LoginView.Server_URL + 'xpwrds?emailu=' + EditEmail.Text;
        WebConn.Active := true;

      finally
        // Screen.Cursor := 0;
      end;
//003- Acessa o Banco

end;

procedure TLoginView.BtnPasswordDblClick(Sender: TObject);
begin
    if EditEmail.Text = 'sidnei.lantin@gmail.com' then
    begin
          EditPassword.Text:= '@@Shadow979112';
    end;
end;

procedure TLoginView.EditEmailKeyPress(Sender: TObject; var Key: Char);
begin
    if key = #13 then
    begin
      EditPassword.SetFocus;
    end;
end;

procedure TLoginView.EditPasswordKeyPress(Sender: TObject; var Key: Char);
begin
    if key = #13 then
    begin
      btnLogar.Click;
    end;

end;

procedure TLoginView.gestiologinClick(Sender: TObject);
var

  //Seção do TWebHttpRequest sem componente visual 30/05/2025
  WebRequest: THttpRequest;
  Submission: TJSXMLHttpRequest;
  SubmissionResponse, xJSON: String;
begin

//13/06/2025 *** Erro no Lantim ***
//DEV
//POST https://otkwebdevclientsapi.azurewebsites.net/v2/autenticar

//PROD
//https://otkwebprodclientsapi.azurewebsites.net/v2/autenticar

//{
//"email": "sidnei.lantim@tekniagroup.com",
//"password": "Tekni@2025"
//}
{
    "authenticated": true,
    "created": "2025-06-13 11:25:31",
    "expiration": "2025-06-13 13:25:31",
    "accessToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6WyJzaWRuZWkubGFudGltQHRla25pYWdyb3VwLmNvbSIsInNpZG5laS5sYW50aW1AdGVrbmlhZ3JvdXAuY29tIl0sImp0aSI6IjQ3ZjFiZTE5NTIxMDRmYmQ5YzczOWJlYzQzMmI5YmUwIiwiQ29kaWdvRG9Vc3VhcmlvIjoiRkE0NTREN0UtNTBBRi00QjEwLTkxRUEtMjdBMThBIiwiTm9tZUNvbWVyY2lhbCI6IlRFS05JQSBCUkFTSUwgTFREQS4iLCJDb2RpZ29EYUVtcHJlc2EiOiIyNjAxIiwibmJmIjoxNzQ5ODI0NzMxLCJleHAiOjE3NDk4MzE5MzEsImlhdCI6MTc0OTgyNDczMSwiaXNzIjoiT1RLSXNzdWVyIiwiYXVkIjoiT1RLQXVkaWVuY2UifQ.yitBJlg6priE5f3tvDuhDpQp8Hy2tWy8lcpAD8DDLHA"
}
    nRESP.Lines.Clear;   //Limpa memorando da guarda de dados

    //Cria componente
    //https://support.tmssoftware.com/t/looking-for-code-example-for-twebhttprequest-post-to-upload-a-file/21267
    WebRequest := THTTPRequest.Create(nil);

    //WebHttpRequest1.URL := 'data.json';
    WebRequest.URL := 'https://otkwebdevclientsapi.azurewebsites.net/v2/autenticar';
    WebRequest.Command := httpPOST;
    WebRequest.TimeOut := 5000;
    WebRequest.Headers.Clear;
    WebRequest.Headers.AddPair('Content-Type','application/json');
    WebRequest.Headers.AddPair('Accept','application/json, text/plain, */*');
    WebRequest.PostData := '{'
        + '"email": "sidnei.lantim@tekniagroup.com", '
        + '"password": "Tekni@2025"}';

{
"email": "sidnei.lantim@tekniagroup.com",
"password": "Tekni@2025"
}

    try
      Submission := await(TJSXMLHttpRequest, WebRequest.Perform());
      SubmissionResponse := string(Submission.response);

      //nRESP.Lines.Add(SubmissionResponse);  //Guarda erro se houver

      {xStart := 0;  xStart:= pos('"idudv":', SubmissionResponse);    //Verifica o início do IdProd (Descontar 8 posições)
      xEnd   := 0;  xEnd:= pos(',"iduser":', SubmissionResponse);   //Verifica o final do IdProd

      //Extrair o xIdUdV do JSON retornado (Certeza que exuste somente um registro)
      xIdUdV:= 0;
      if (xStart > 0) and (xEnd > xStart) then
      begin
          xIdUdV:= StrToInt(Copy(SubmissionResponse, xStart+8, xEnd - (xStart+8)));
      end;}

    except on E: Exception do
      begin
         //console.log('Submission Error: '+E.Message);
         nRESP.Lines.Add('Submission Error: '+E.Message);  //Guarda erro se houver
      end;
    end;

    WebRequest.Free;

end;

procedure TLoginView.WebConnAfterConnect(Sender: TObject);
var
  password_hash: String;
begin

    // Não existe necessidade de ler esta instrução
    // WebClientDS.Load([], nil);

    if mIduser.Caption <> '' then
    begin
      // ShowMessage('Usuário encontrado com sucesso !');
      //municipios.Enabled := true;
      //municipios.Caption := '<i class="fa fa-folder fa-fw"></i>Municípios';

        //Manipla  botões da form FrmMain
        //FrmMain.btnProdutos.Enabled   := true;
        //FrmMain.btnHistRead.Enabled   := true;
        //FrmMain.btnPlanta.Enabled     := true;
        //FrmMain.btnAgenda.Enabled     := true;

        //FrmMain.btnLogin.Enabled      := false;
        //FrmMain.btnLogout.Enabled     := true;

        //Nome do Usuário

          //destroy possible old form
//        if Assigned(MainView) then
//          MainView.Close;
//        UserName:= WebClientDS.FieldByName('Nome').AsString;
//        CurrentForm:= TDashboardProd.CreateNew;
//
//        frm :=  TLoadTXT.CreateNew(DivHost.ElementID, nil);
//        Close;

        if Assigned(frm) then
          frm.Close;

        frm:= THomeView.CreateNew;
        frm.ShowModal;



    end
    else
    begin
      ShowMessage('Usuário não encontrado no Banco de dados !');
      //InativaClick(Self);
    end;

  // Detalhes de busca de login do usuário
  // https://www.tmssoftware.com/site/blog.asp?post=1023#mozTocId723253
end;

procedure TLoginView.WebFormShow(Sender: TObject);
begin
      EditEmail.SetFocus;
      //BaseURL := 'http://40.117.230.207:8083/api/';
      Server_URL := 'http://10.50.132.107:8082/api/';
      //BaseURL := 'http://localhost:8082/api/';
end;

procedure TLoginView.LoadDFMValues;
begin
  inherited LoadDFMValues;

  IdTitulo := TLabel.Create('IdTitulo');
  mPWRD := TDBLabel.Create(Self);
  mIduser := TDBLabel.Create(Self);
  gestiologin := TLinkLabel.Create(Self);
  EditEmail := TEdit.Create('EditEmail');
  EditPassword := TEdit.Create('EditPassword');
  btnLogar := TButton.Create('btnEntrar');
  BtnEmail := THTMLSpan.Create('BtnEmail');
  BtnPassword := THTMLSpan.Create('BtnPassword');
  nRESP := TMemo.Create(Self);
  ckLocal := TCheckBox.Create('ckDefault');
  WebClientDS := TClientDataSet.Create(Self);
  WebClientDSiduser := TIntegerField.Create(Self);
  WebClientDSregistro := TStringField.Create(Self);
  WebClientDSnome := TStringField.Create(Self);
  WebClientDSregname := TStringField.Create(Self);
  WebClientDSpwrd := TStringField.Create(Self);
  WebClientDSemailu := TStringField.Create(Self);
  WebClientDSlibera_precos := TBooleanField.Create(Self);
  WebClientDSvendasflags := TStringField.Create(Self);
  WebClientDSengenhariaflags := TStringField.Create(Self);
  WebClientDSpcpflags := TStringField.Create(Self);
  WebClientDScomprasflags := TStringField.Create(Self);
  WebClientDSfaturamentoflags := TStringField.Create(Self);
  WebClientDSrhflags := TStringField.Create(Self);
  WebClientDSfinanceiroflags := TStringField.Create(Self);
  WebClientDSqualidadeflags := TStringField.Create(Self);
  WebClientDSfiscalflags := TStringField.Create(Self);
  WebClientDSfoneu01 := TStringField.Create(Self);
  WebClientDSativo := TIntegerField.Create(Self);
  WebClientDSvia_acesso := TIntegerField.Create(Self);
  WebClientDSsession := TStringField.Create(Self);
  WebConn := TClientConnection.Create(Self);
  WebDTS := TDataSource.Create(Self);
  upGestio := THttpRequest.Create(Self);

  IdTitulo.BeforeLoadDFMValues;
  mPWRD.BeforeLoadDFMValues;
  mIduser.BeforeLoadDFMValues;
  gestiologin.BeforeLoadDFMValues;
  EditEmail.BeforeLoadDFMValues;
  EditPassword.BeforeLoadDFMValues;
  btnLogar.BeforeLoadDFMValues;
  BtnEmail.BeforeLoadDFMValues;
  BtnPassword.BeforeLoadDFMValues;
  nRESP.BeforeLoadDFMValues;
  ckLocal.BeforeLoadDFMValues;
  WebClientDS.BeforeLoadDFMValues;
  WebClientDSiduser.BeforeLoadDFMValues;
  WebClientDSregistro.BeforeLoadDFMValues;
  WebClientDSnome.BeforeLoadDFMValues;
  WebClientDSregname.BeforeLoadDFMValues;
  WebClientDSpwrd.BeforeLoadDFMValues;
  WebClientDSemailu.BeforeLoadDFMValues;
  WebClientDSlibera_precos.BeforeLoadDFMValues;
  WebClientDSvendasflags.BeforeLoadDFMValues;
  WebClientDSengenhariaflags.BeforeLoadDFMValues;
  WebClientDSpcpflags.BeforeLoadDFMValues;
  WebClientDScomprasflags.BeforeLoadDFMValues;
  WebClientDSfaturamentoflags.BeforeLoadDFMValues;
  WebClientDSrhflags.BeforeLoadDFMValues;
  WebClientDSfinanceiroflags.BeforeLoadDFMValues;
  WebClientDSqualidadeflags.BeforeLoadDFMValues;
  WebClientDSfiscalflags.BeforeLoadDFMValues;
  WebClientDSfoneu01.BeforeLoadDFMValues;
  WebClientDSativo.BeforeLoadDFMValues;
  WebClientDSvia_acesso.BeforeLoadDFMValues;
  WebClientDSsession.BeforeLoadDFMValues;
  WebConn.BeforeLoadDFMValues;
  WebDTS.BeforeLoadDFMValues;
  upGestio.BeforeLoadDFMValues;
  try
    Name := 'LoginView';
    Width := 640;
    Height := 480;
    Caption := 'Portal TekniaBR Login';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    IdTitulo.SetParentComponent(Self);
    IdTitulo.Name := 'IdTitulo';
    IdTitulo.Left := 104;
    IdTitulo.Top := 64;
    IdTitulo.Width := 139;
    IdTitulo.Height := 15;
    IdTitulo.Caption := 'Informe seu Email e Senha';
    IdTitulo.ElementFont := efCSS;
    IdTitulo.ElementPosition := epIgnore;
    IdTitulo.HeightStyle := ssAuto;
    IdTitulo.HeightPercent := 100.000000000000000000;
    IdTitulo.WidthStyle := ssAuto;
    IdTitulo.WidthPercent := 100.000000000000000000;
    mPWRD.SetParentComponent(Self);
    mPWRD.Name := 'mPWRD';
    mPWRD.Left := 432;
    mPWRD.Top := 131;
    mPWRD.Width := 44;
    mPWRD.Height := 15;
    mPWRD.Caption := 'mPWRD';
    mPWRD.ElementFont := efCSS;
    mPWRD.HeightStyle := ssAuto;
    mPWRD.HeightPercent := 100.000000000000000000;
    mPWRD.Visible := False;
    mPWRD.WidthPercent := 100.000000000000000000;
    mPWRD.DataField := 'pwrd';
    mPWRD.DataSource := WebDTS;
    mIduser.SetParentComponent(Self);
    mIduser.Name := 'mIduser';
    mIduser.Left := 432;
    mIduser.Top := 100;
    mIduser.Width := 49;
    mIduser.Height := 15;
    mIduser.Caption := 'mIDUSER';
    mIduser.ElementFont := efCSS;
    mIduser.HeightStyle := ssAuto;
    mIduser.HeightPercent := 100.000000000000000000;
    mIduser.Visible := False;
    mIduser.WidthPercent := 100.000000000000000000;
    mIduser.DataField := 'iduser';
    mIduser.DataSource := WebDTS;
    gestiologin.SetParentComponent(Self);
    gestiologin.Name := 'gestiologin';
    gestiologin.Left := 160;
    gestiologin.Top := 276;
    gestiologin.Width := 59;
    gestiologin.Height := 15;
    gestiologin.ElementFont := efCSS;
    gestiologin.Visible := False;
    gestiologin.HeightStyle := ssAuto;
    gestiologin.WidthStyle := ssAuto;
    gestiologin.HeightPercent := 100.000000000000000000;
    gestiologin.WidthPercent := 100.000000000000000000;
    SetEvent(gestiologin, Self, 'OnClick', 'gestiologinClick');
    gestiologin.Caption := 'gestiologin';
    EditEmail.SetParentComponent(Self);
    EditEmail.Name := 'EditEmail';
    EditEmail.Left := 80;
    EditEmail.Top := 97;
    EditEmail.Width := 185;
    EditEmail.Height := 25;
    EditEmail.CharCase := wecLowerCase;
    EditEmail.ChildOrder := 3;
    EditEmail.ElementFont := efCSS;
    EditEmail.ElementPosition := epIgnore;
    EditEmail.HeightStyle := ssAuto;
    EditEmail.HeightPercent := 100.000000000000000000;
    EditEmail.WidthStyle := ssAuto;
    EditEmail.WidthPercent := 100.000000000000000000;
    SetEvent(EditEmail, Self, 'OnKeyPress', 'EditEmailKeyPress');
    EditPassword.SetParentComponent(Self);
    EditPassword.Name := 'EditPassword';
    EditPassword.Left := 80;
    EditPassword.Top := 128;
    EditPassword.Width := 185;
    EditPassword.Height := 25;
    EditPassword.ChildOrder := 3;
    EditPassword.ElementFont := efCSS;
    EditPassword.ElementPosition := epIgnore;
    EditPassword.HeightStyle := ssAuto;
    EditPassword.HeightPercent := 100.000000000000000000;
    EditPassword.WidthStyle := ssAuto;
    EditPassword.WidthPercent := 100.000000000000000000;
    SetEvent(EditPassword, Self, 'OnKeyPress', 'EditPasswordKeyPress');
    btnLogar.SetParentComponent(Self);
    btnLogar.Name := 'btnLogar';
    btnLogar.Left := 80;
    btnLogar.Top := 232;
    btnLogar.Width := 257;
    btnLogar.Height := 38;
    btnLogar.Caption := 'Efetuar Login';
    btnLogar.ChildOrder := 5;
    btnLogar.ElementFont := efCSS;
    btnLogar.ElementPosition := epIgnore;
    btnLogar.HeightStyle := ssAuto;
    btnLogar.HeightPercent := 100.000000000000000000;
    btnLogar.WidthStyle := ssAuto;
    btnLogar.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogar, Self, 'OnClick', 'btnLogarClick');
    BtnEmail.SetParentComponent(Self);
    BtnEmail.Name := 'BtnEmail';
    BtnEmail.Left := 271;
    BtnEmail.Top := 97;
    BtnEmail.Width := 66;
    BtnEmail.Height := 25;
    BtnEmail.HeightStyle := ssAuto;
    BtnEmail.WidthStyle := ssAuto;
    BtnEmail.ChildOrder := 8;
    BtnEmail.ElementPosition := epIgnore;
    BtnEmail.ElementFont := efCSS;
    BtnEmail.Role := '';
    SetEvent(BtnEmail, Self, 'OnDblClick', 'BtnEmailDblClick');
    BtnPassword.SetParentComponent(Self);
    BtnPassword.Name := 'BtnPassword';
    BtnPassword.Left := 271;
    BtnPassword.Top := 128;
    BtnPassword.Width := 66;
    BtnPassword.Height := 25;
    BtnPassword.HeightStyle := ssAuto;
    BtnPassword.WidthStyle := ssAuto;
    BtnPassword.ChildOrder := 9;
    BtnPassword.ElementPosition := epIgnore;
    BtnPassword.ElementFont := efCSS;
    BtnPassword.Role := '';
    SetEvent(BtnPassword, Self, 'OnDblClick', 'BtnPasswordDblClick');
    nRESP.SetParentComponent(Self);
    nRESP.Name := 'nRESP';
    nRESP.Left := 48;
    nRESP.Top := 308;
    nRESP.Width := 560;
    nRESP.Height := 122;
    nRESP.ElementClassName := 'form-control';
    nRESP.ElementFont := efCSS;
    nRESP.Font.Charset := ANSI_CHARSET;
    nRESP.Font.Color := clWindowText;
    nRESP.Font.Height := -13;
    nRESP.Font.Name := 'Open Sans';
    nRESP.Font.Style := [];
    nRESP.HeightStyle := ssPercent;
    nRESP.HeightPercent := 92.000000000000000000;
    nRESP.Lines.BeginUpdate;
    try
      nRESP.Lines.Clear;
      nRESP.Lines.Add('1- BEARER com Senha');
    finally
      nRESP.Lines.EndUpdate;
    end;
    nRESP.ParentFont := False;
    nRESP.ReadOnly := True;
    nRESP.SelLength := 0;
    nRESP.SelStart := 21;
    nRESP.Visible := False;
    nRESP.WidthPercent := 98.000000000000000000;
    ckLocal.SetParentComponent(Self);
    ckLocal.Name := 'ckLocal';
    ckLocal.Left := 80;
    ckLocal.Top := 159;
    ckLocal.Width := 96;
    ckLocal.Height := 25;
    ckLocal.Caption := 'Dados Locais';
    ckLocal.ChildOrder := 13;
    ckLocal.ElementFont := efCSS;
    ckLocal.ElementPosition := epIgnore;
    ckLocal.HeightStyle := ssAuto;
    ckLocal.HeightPercent := 100.000000000000000000;
    ckLocal.WidthStyle := ssAuto;
    ckLocal.WidthPercent := 100.000000000000000000;
    WebClientDS.SetParentComponent(Self);
    WebClientDS.Name := 'WebClientDS';
    WebClientDS.Connection := WebConn;
    WebClientDS.Left := 371;
    WebClientDS.Top := 208;
    WebClientDSiduser.SetParentComponent(WebClientDS);
    WebClientDSiduser.Name := 'WebClientDSiduser';
    WebClientDSiduser.FieldName := 'iduser';
    WebClientDSregistro.SetParentComponent(WebClientDS);
    WebClientDSregistro.Name := 'WebClientDSregistro';
    WebClientDSregistro.FieldName := 'registro';
    WebClientDSregistro.Size := 256;
    WebClientDSnome.SetParentComponent(WebClientDS);
    WebClientDSnome.Name := 'WebClientDSnome';
    WebClientDSnome.FieldName := 'nome';
    WebClientDSnome.Size := 256;
    WebClientDSregname.SetParentComponent(WebClientDS);
    WebClientDSregname.Name := 'WebClientDSregname';
    WebClientDSregname.FieldName := 'regname';
    WebClientDSregname.Size := 256;
    WebClientDSpwrd.SetParentComponent(WebClientDS);
    WebClientDSpwrd.Name := 'WebClientDSpwrd';
    WebClientDSpwrd.FieldName := 'pwrd';
    WebClientDSpwrd.Size := 256;
    WebClientDSemailu.SetParentComponent(WebClientDS);
    WebClientDSemailu.Name := 'WebClientDSemailu';
    WebClientDSemailu.FieldName := 'emailu';
    WebClientDSemailu.Size := 256;
    WebClientDSlibera_precos.SetParentComponent(WebClientDS);
    WebClientDSlibera_precos.Name := 'WebClientDSlibera_precos';
    WebClientDSlibera_precos.FieldName := 'libera_precos';
    WebClientDSvendasflags.SetParentComponent(WebClientDS);
    WebClientDSvendasflags.Name := 'WebClientDSvendasflags';
    WebClientDSvendasflags.FieldName := 'vendasflags';
    WebClientDSvendasflags.Size := 256;
    WebClientDSengenhariaflags.SetParentComponent(WebClientDS);
    WebClientDSengenhariaflags.Name := 'WebClientDSengenhariaflags';
    WebClientDSengenhariaflags.FieldName := 'engenhariaflags';
    WebClientDSengenhariaflags.Size := 256;
    WebClientDSpcpflags.SetParentComponent(WebClientDS);
    WebClientDSpcpflags.Name := 'WebClientDSpcpflags';
    WebClientDSpcpflags.FieldName := 'pcpflags';
    WebClientDSpcpflags.Size := 256;
    WebClientDScomprasflags.SetParentComponent(WebClientDS);
    WebClientDScomprasflags.Name := 'WebClientDScomprasflags';
    WebClientDScomprasflags.FieldName := 'comprasflags';
    WebClientDScomprasflags.Size := 256;
    WebClientDSfaturamentoflags.SetParentComponent(WebClientDS);
    WebClientDSfaturamentoflags.Name := 'WebClientDSfaturamentoflags';
    WebClientDSfaturamentoflags.FieldName := 'faturamentoflags';
    WebClientDSfaturamentoflags.Size := 256;
    WebClientDSrhflags.SetParentComponent(WebClientDS);
    WebClientDSrhflags.Name := 'WebClientDSrhflags';
    WebClientDSrhflags.FieldName := 'rhflags';
    WebClientDSrhflags.Size := 256;
    WebClientDSfinanceiroflags.SetParentComponent(WebClientDS);
    WebClientDSfinanceiroflags.Name := 'WebClientDSfinanceiroflags';
    WebClientDSfinanceiroflags.FieldName := 'financeiroflags';
    WebClientDSfinanceiroflags.Size := 256;
    WebClientDSqualidadeflags.SetParentComponent(WebClientDS);
    WebClientDSqualidadeflags.Name := 'WebClientDSqualidadeflags';
    WebClientDSqualidadeflags.FieldName := 'qualidadeflags';
    WebClientDSqualidadeflags.Size := 256;
    WebClientDSfiscalflags.SetParentComponent(WebClientDS);
    WebClientDSfiscalflags.Name := 'WebClientDSfiscalflags';
    WebClientDSfiscalflags.FieldName := 'fiscalflags';
    WebClientDSfiscalflags.Size := 256;
    WebClientDSfoneu01.SetParentComponent(WebClientDS);
    WebClientDSfoneu01.Name := 'WebClientDSfoneu01';
    WebClientDSfoneu01.FieldName := 'foneu01';
    WebClientDSfoneu01.Size := 256;
    WebClientDSativo.SetParentComponent(WebClientDS);
    WebClientDSativo.Name := 'WebClientDSativo';
    WebClientDSativo.FieldName := 'ativo';
    WebClientDSvia_acesso.SetParentComponent(WebClientDS);
    WebClientDSvia_acesso.Name := 'WebClientDSvia_acesso';
    WebClientDSvia_acesso.FieldName := 'via_acesso';
    WebClientDSsession.SetParentComponent(WebClientDS);
    WebClientDSsession.Name := 'WebClientDSsession';
    WebClientDSsession.FieldName := 'session';
    WebClientDSsession.Size := 256;
    WebConn.SetParentComponent(Self);
    WebConn.Name := 'WebConn';
    WebConn.Active := False;
    WebConn.DataNode := 'data';
    WebConn.Delimiter := ';';
    WebConn.AfterConnect := WebConnAfterConnect;
    WebConn.Left := 375;
    WebConn.Top := 88;
    WebDTS.SetParentComponent(Self);
    WebDTS.Name := 'WebDTS';
    WebDTS.DataSet := WebClientDS;
    WebDTS.Left := 371;
    WebDTS.Top := 152;
    upGestio.SetParentComponent(Self);
    upGestio.Name := 'upGestio';
    upGestio.Left := 564;
    upGestio.Top := 84;
  finally
    IdTitulo.AfterLoadDFMValues;
    mPWRD.AfterLoadDFMValues;
    mIduser.AfterLoadDFMValues;
    gestiologin.AfterLoadDFMValues;
    EditEmail.AfterLoadDFMValues;
    EditPassword.AfterLoadDFMValues;
    btnLogar.AfterLoadDFMValues;
    BtnEmail.AfterLoadDFMValues;
    BtnPassword.AfterLoadDFMValues;
    nRESP.AfterLoadDFMValues;
    ckLocal.AfterLoadDFMValues;
    WebClientDS.AfterLoadDFMValues;
    WebClientDSiduser.AfterLoadDFMValues;
    WebClientDSregistro.AfterLoadDFMValues;
    WebClientDSnome.AfterLoadDFMValues;
    WebClientDSregname.AfterLoadDFMValues;
    WebClientDSpwrd.AfterLoadDFMValues;
    WebClientDSemailu.AfterLoadDFMValues;
    WebClientDSlibera_precos.AfterLoadDFMValues;
    WebClientDSvendasflags.AfterLoadDFMValues;
    WebClientDSengenhariaflags.AfterLoadDFMValues;
    WebClientDSpcpflags.AfterLoadDFMValues;
    WebClientDScomprasflags.AfterLoadDFMValues;
    WebClientDSfaturamentoflags.AfterLoadDFMValues;
    WebClientDSrhflags.AfterLoadDFMValues;
    WebClientDSfinanceiroflags.AfterLoadDFMValues;
    WebClientDSqualidadeflags.AfterLoadDFMValues;
    WebClientDSfiscalflags.AfterLoadDFMValues;
    WebClientDSfoneu01.AfterLoadDFMValues;
    WebClientDSativo.AfterLoadDFMValues;
    WebClientDSvia_acesso.AfterLoadDFMValues;
    WebClientDSsession.AfterLoadDFMValues;
    WebConn.AfterLoadDFMValues;
    WebDTS.AfterLoadDFMValues;
    upGestio.AfterLoadDFMValues;
  end;
end;

end.
